<!--  -->
<template>
  <div>
    <div class="dasdw">
      <div>选择商户：</div>
      <div>
        <el-tag v-if="dawobj.merchant_name" style="margin-right:10px">{{ dawobj.merchant_name }}</el-tag>
        <el-button size="mini" type="primary" @click="choose">选择</el-button>
      </div>
    </div>
    <div class="dasdw" style="margin-top:20px">
      <div>选择公众号：</div>
      <div>
        <el-tag
          v-for="itemr,index in parameter.app_ids"
          :key="index"
          style="margin-right:10px;margin-bottom:5px;"
          closable
          :type="itemr.type"
          @close="rightclick(itemr.id,index)"
        >
          {{ itemr.name }}
        </el-tag>
        <el-button size="mini" type="primary" @click="chooseaccout">选择</el-button>
      </div>
    </div>
    <div style="margin-top:50px">
      <el-button size="mini" type="primary" @click="dadk">确定</el-button>
    </div>
    <el-dialog
      :visible.sync="dialogVisibler"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
    >
      <ChooseaccountDialog ref="chhoseaccout" @closedialog="closedialog" @closedialogone="closedialogone" />
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisiblerw"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
    >
      <offawed ref="offawedsdw" @uodata="uodata" />
    </el-dialog>
    <el-dialog
      title="绑定公众号失败原因"
      :visible.sync="errordialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @close="dajwe"
    >
      <errorbind ref="errordialogview" />
    </el-dialog>
  </div>
</template>

<script>
import ChooseaccountDialog from './ChooseaccountDialog.vue'
import offawed from './offawed.vue'
import errorbind from './errorbind.vue'
import { merchantbindoa } from '@/api/sourceMaterial.js'
export default {
  components: {
    ChooseaccountDialog,
    offawed,
    errorbind
  },
  data() {
    return {
      parameter: {
        app_ids: []
      },
      dawobj: {},
      dialogVisibler: false,
      dialogVisiblerw: false,
      errordialog: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    chooseaccout() {
      // app_ids: parameter.app_ids.map(item => item.id)
      this.dialogVisibler = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.chhoseaccout.sendrs(this.parameter.app_ids)
      }, 100)
    },
    rightclick(id, index) {
      this.parameter.app_ids.splice(index, 1)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.chhoseaccout.set(id)
      }, 100)

      console.log(id, index)
    },
    closedialog(arr) {
      this.app_ids = arr
      this.dialogVisibler = false
    },
    closedialogone(arr) {
      this.app_ids = arr
    },
    choose() {
      this.dialogVisiblerw = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.offawedsdw.set()
      }, 100)
    },
    uodata(item) {
      this.dialogVisiblerw = false
      this.dawobj = item
    },
    async dadk() {
      if (!this.dawobj.merchant_name) {
        this.$message.error('请选择商户')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.parameter.app_ids.length == 0) {
        this.$message.error('请选择公众号')
        return
      }
      const data = await merchantbindoa({
        app_ids: this.parameter.app_ids.map(item => item.id),
        merchant_id: this.dawobj.merchant_id
      })
      console.log('data', data)
      // eslint-disable-next-line eqeqeq
      if (data.data.failList.length !== 0) {
        this.errordialog = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.errordialogview.send(data.data.failList)
        }, 100)

        // this.$message.error(`未绑定成功的公众号有：${data.data.fail.join(',')}`)
      } else {
        this.$message({
          type: 'success',
          message: '绑定成功'
        })
        this.$emit('updata')
      }

      console.log('data', data)
    },
    dajwe() {
      this.$emit('updata')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.dasdw{
display: flex;
align-items: center;
}
</style>
